import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space8 } = theme();

  return StyleSheet.create({
    buttonIcon: {
      padding: 0,
    },
    container: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: space8,
      width: "100%",
    },
  });
};

export { style };
